import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Typography } from '@chilecompra/react-kit/components'
import Carousel from '../../components/Basics/Carousel'
import RegionImage from './HomeRegions.regionImage'
import { REGIONS_CAROUSEL } from '../../config/settings/constants'
import ProtectByFeatures from '../../security/ProtectByFeatures'
import {
  ContainerImg,
  Content,
  GridContainer,
  GridItem,
  HeaderText,
  Image,
  Root,
  SectionHeaderContainer,
  TextImg
} from './HomeRegions.styles'

/**
 * The HomeRegions's container.
 */
const HomeRegions = () => {
  const { size } = useViewport()

  const regions = Object.values(REGIONS_CAROUSEL[size.isUpToMedium ? 'desktop' : 'mobile']).map(item => (
    <RegionImage
      key={size.isUpToMedium ? item.carouselGroup : item.id}
      imageOne={size.isUpToMedium ? item.imageOne : item.image}
      imageTwo={item.imageTwo}
      imageThree={item.imageThree}
      nameOne={size.isUpToMedium ? item.nameOne : item.name}
      nameTwo={item.nameTwo}
      nameThree={item.nameThree}
    />
  ))

  return (
    <Root>
      <SectionHeaderContainer height="auto">
        <Content>
          <HeaderText margin={size.isUpToMedium ? '96px 0 0' : '48px 0 0'}>
            Compras públicas del Estado de Chile
          </HeaderText>
          <Typography
            color="white"
            fontSize="34px"
            fontWeight="bold"
            lineHeight="38px"
            margin={size.isUpToMedium ? '16px 0' : '24px 0'}
            variant="h2"
            width={size.isUpToMedium ? '412px' : undefined}
          >
            Regiones de Chile
          </Typography>
          <GridContainer>
            <GridItem xs={size.isUpToMedium ? 5 : 12}>
              <Typography
                color="white"
                fontSize="18px"
                lineHeight="24px"
                variant="body1"
                width={size.isUpToMedium ? '448px' : undefined}
              >
                Accede a la información de compras públicas realizadas en cada región de Chile.
              </Typography>
            </GridItem>
          </GridContainer>
          <GridContainer margin={size.isUpToMedium ? '64px 0' : '48px 0'}>
            <GridItem xs={12}>
              <Carousel items={regions} navButtonsAlwaysVisible />
            </GridItem>
            <ProtectByFeatures rule={features => features['contingencies.home']}>
              <GridItem xs={12} md margin={size.isUpToMedium ? undefined : '48px 0 0'}>
                <ContainerImg height="295px" textAlign="left" width={size.isUpToMedium ? '406px' : '100%'}>
                  <Image src="/assets/images/covid-19.png" />
                  <TextImg fontSize="40px" left="40%" top="80%">
                    Coronavirus COVID-19
                  </TextImg>
                </ContainerImg>
              </GridItem>
            </ProtectByFeatures>
          </GridContainer>
        </Content>
      </SectionHeaderContainer>
    </Root>
  )
}

export default HomeRegions
